import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-order-statuses',
  templateUrl: './order-statuses.component.html',
  styleUrls: ['./order-statuses.component.css']
})
export class OrderStatusesComponent implements OnInit {
    public itemsListOrderStatuses: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadOrderStatuses(): Promise<void> {
        this.itemsListOrderStatuses = await this.datatask.Post(2513);
    }

    private async init() {
        this.loadOrderStatuses();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderStatuses', {
//        templateUrl: 'views/components/views/orderStatuses/orderStatuses.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['orderStatusesService', function (orderStatusesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListOrderStatuses: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadOrderStatuses() {
//                vm.model.itemsListOrderStatuses = await orderStatusesService.listOrderStatuses();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadOrderStatuses();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
